import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NotificationDashboard } from './components/dashboard/component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { NotificationApiService } from './services/notification-api-service';
import { NewNotification } from './components/new-notification/component';

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: [NotificationDashboard, NewNotification],
  providers: [NotificationApiService],
  exports: [NotificationDashboard],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NotificationModule {}
